import { type App, defineAsyncComponent } from 'vue'

const components = {
  AgentReadsPanel: defineAsyncComponent(() => import('./AgentReadsPanel.vue')),
  BrandCard: defineAsyncComponent(() => import('./BrandCard.vue')),
  BrandCreateForm: defineAsyncComponent(() => import('./BrandCreateForm.vue')),
  BrandKitPanel: defineAsyncComponent(() => import('./BrandKitPanel.vue')),
  BrandMemoryPanel: defineAsyncComponent(() => import('./BrandMemoryPanel.vue')),
  BrandReextractDialog: defineAsyncComponent(() => import('./BrandReextractDialog.vue')),
  BrandPlate: defineAsyncComponent(() => import('./BrandPlate.vue')),
  BrandsEmptyState: defineAsyncComponent(() => import('./BrandsEmptyState.vue')),
  BrandPage: defineAsyncComponent(() => import('../pages/BrandPage.vue')),
  BrandReviewPage: defineAsyncComponent(() => import('../pages/BrandReviewPage.vue')),
  BrandTypographyPage: defineAsyncComponent(() => import('../pages/BrandTypographyPage.vue')),
  FontSourcePicker: defineAsyncComponent(() => import('./fonts/FontSourcePicker.vue')),
  ProvenanceNote: defineAsyncComponent(() => import('./ProvenanceNote.vue')),
  KitColorsCard: defineAsyncComponent(() => import('./kit/KitColorsCard.vue')),
  KitFontDialog: defineAsyncComponent(() => import('./kit/KitFontDialog.vue')),
  KitLogos: defineAsyncComponent(() => import('./kit/KitLogos.vue')),
  BrandProfilePanel: defineAsyncComponent(() => import('./profile/BrandProfilePanel.vue')),
  BrandResearchPanel: defineAsyncComponent(() => import('./BrandResearchPanel.vue')),
  ProfileSection: defineAsyncComponent(() => import('./profile/ProfileSection.vue')),
  BrandVoicePanel: defineAsyncComponent(() => import('./voice/BrandVoicePanel.vue')),
  BrandVoicePart: defineAsyncComponent(() => import('./voice/BrandVoicePart.vue')),
  BrandVoiceSection: defineAsyncComponent(() => import('./voice/BrandVoiceSection.vue')),
  BrandVoiceSections: defineAsyncComponent(() => import('./voice/BrandVoiceSections.vue')),
  ReviewBasicsStep: defineAsyncComponent(() => import('./review/ReviewBasicsStep.vue')),
  ReviewConfirmStep: defineAsyncComponent(() => import('./review/ReviewConfirmStep.vue')),
  ReviewKitStep: defineAsyncComponent(() => import('./review/ReviewKitStep.vue')),
  ReviewKitSection: defineAsyncComponent(() => import('./review/ReviewKitSection.vue')),
  ReviewPreview: defineAsyncComponent(() => import('./review/ReviewPreview.vue')),
  ReviewProfileStep: defineAsyncComponent(() => import('./review/ReviewProfileStep.vue')),
  ReviewRow: defineAsyncComponent(() => import('./review/ReviewRow.vue')),
  ReviewStepCard: defineAsyncComponent(() => import('./review/ReviewStepCard.vue')),
  ExtractionPending: defineAsyncComponent(() => import('./review/ExtractionPending.vue')),
  BasicsEditDialog: defineAsyncComponent(() => import('./review/BasicsEditDialog.vue')),
  ColorEditDialog: defineAsyncComponent(() => import('./review/ColorEditDialog.vue')),
  FontEditDialog: defineAsyncComponent(() => import('./review/FontEditDialog.vue')),
  LogoEditDialog: defineAsyncComponent(() => import('./review/LogoEditDialog.vue')),
  FontBrowserDialog: defineAsyncComponent(() => import('./typography/FontBrowserDialog.vue')),
  InstagramPreview: defineAsyncComponent(() => import('./typography/InstagramPreview.vue')),
  TypeRoleRow: defineAsyncComponent(() => import('./typography/TypeRoleRow.vue'))
}

type Registry = typeof components

declare module 'vue' {
  interface GlobalComponents extends Registry {}
}

export const registerComponents = (app: App) => {
  for (const [name, component] of Object.entries(components)) {
    app.component(name, component)
  }
}
